import { useState, useEffect, FC } from 'react';
import { ThemeProvider } from 'styled-components';

export enum ThemeEnum {
  light,
  dark
}

interface IThemeHandler {
  children: any;
  setLogoCallback?: (logo: string | ArrayBuffer | null) => void;
  setThemeCallback?: (theme: string) => void;
}

export const ThemeHandler: FC<IThemeHandler> = ({
  children,
  setLogoCallback,
  setThemeCallback
}) => {
  const [theme, setTheme] = useState<ThemeEnum>();
  const [logo, setLogo] = useState<string | ArrayBuffer | null>();

  useEffect(() => {
    const storedTheme = parseInt(localStorage.getItem('theme') || '0');
    setTheme(storedTheme);

    const base64 = localStorage.getItem('customer-logo');
    if (base64) {
      setLogo(base64);
    }
  }, []);

  const resetTheme = () => {
    setTheme(ThemeEnum.light);
    setLogo(undefined);

    localStorage.removeItem('customer-logo');
    localStorage.removeItem('theme');
    setLogoCallback && setLogoCallback(null);
  };

  useEffect(() => {
    if (theme !== undefined) {
      localStorage.setItem('theme', JSON.stringify(theme));
      setThemeCallback && setThemeCallback(ThemeEnum[theme]);
    }
    if (logo) {
      localStorage.setItem('customer-logo', logo as string);
      setLogoCallback && setLogoCallback(logo);
    }
  }, [theme, logo]);

  return (
    <ThemeProvider theme={{ theme, setTheme, resetTheme, logo, setLogo }}>
      {children}
    </ThemeProvider>
  );
};
